<div mat-dialog-title class="dialog-title-row">
  <span class="dialog-title-text">Grant Contractor Permissions</span>

  <button
    mat-button
    class="close-btn"
    aria-label="Close"
    (click)="onNoClick()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content class="dialog-content">
  <form [formGroup]="formPermissions" autocomplete="off">
    <mat-checkbox
      id="managePermission"
      formControlName="managePermission"
      (change)="onCheckEventPermissions($event)"
      class="permission-checkbox">

      <span class="permission-text">
        I agree my contractor may upload documents to my dashboard. I also acknowledge that
        providing my contractor with permission will enable them to view any information I upload
        regarding proof of residency.
      </span>

    </mat-checkbox>
  </form>
</div>

<div mat-dialog-actions class="dialog-actions">
  <button
    mat-flat-button
    color="primary"
    [disabled]="disableGrantSave"
    (click)="onClickPermissions()">
    AGREE
  </button>
</div>
